import {
  EmployeeAction,
  EmployeeState,
  SET_EMPLOYEES,
  SET_EMPLOYEES_LOADED,
  SET_EMPLOYEE_FILTER,
  SET_SELECTED_EMPLOYEE,
} from '../types'

const initialState: EmployeeState = {
  employees: [],
  isEmployeesLoaded: false,
  employeeFilter: {
    name: '',
    genders: ['true', 'false'],
    phone: '',
    stationName: '',
  },
}

export const employeeReducer = (
  state = initialState,
  action: EmployeeAction
): EmployeeState => {
  switch (action.type) {
    case SET_EMPLOYEES:
      return {
        ...state,
        employees: action.payload,
      }
    case SET_EMPLOYEES_LOADED:
      return {
        ...state,
        isEmployeesLoaded: action.payload,
      }
    case SET_SELECTED_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: action.payload,
      }
    case SET_EMPLOYEE_FILTER:
      return {
        ...state,
        employeeFilter: action.payload,
      }
    default:
      return state
  }
}
